import { render, staticRenderFns } from "./AdmiralAvatar.vue?vue&type=template&id=1746e244"
import script from "./AdmiralAvatar.vue?vue&type=script&lang=ts"
export * from "./AdmiralAvatar.vue?vue&type=script&lang=ts"
import style0 from "./AdmiralAvatar.vue?vue&type=style&index=0&id=1746e244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports